export const API_PROTOCOL_URL = import.meta.env.VITE_URL_PROTOCOL

export const API_BASE_URL = API_PROTOCOL_URL + import.meta.env.VITE_BASE_PATH + '/api' // import.meta.env instead of process.env for enviroment variables with VITE_ in variables names

export const CALCULATIONS_BASE_URL = API_BASE_URL+'/calculations'

export const ASSETS_BASE_URL = "https://" + import.meta.env.VITE_ASSETS_API_PATH
